import * as API from '@siloreal:shared:api';

const LAB_PROTOCOL_EXPORT_ENDPOINT = '/lab/protocols/export/manualInput';

export type ExportLabProtocolServiceContract = {
  labTemplateId: number;
  silobagIds: readonly string[];
  signal?: AbortSignal;
};

export type ExportLabProtocolResponse = Blob;

export async function exportLabProtocolService(
  contract: ExportLabProtocolServiceContract
): Promise<ExportLabProtocolResponse> {
  const { data } = await API.http.fetch.blob.post(LAB_PROTOCOL_EXPORT_ENDPOINT, {
    body: {
      lab_template_id: contract.labTemplateId,
      silobags: contract.silobagIds,
    },
    signal: contract.signal,
  });

  return data;
}
